<template>
  <v-container>
    <v-row justify="space-between">
      <v-col
        cols="12" sm="6" md="8" lg="9"
        class="d-flex align-center title text-uppercase primary--text"
      >
        Sections
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-btn @click="openSectionEditor('create')" block color="primary">
          {{ $t('actions.create') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-data-table
            :headers="sectionsTable.headers"
            :items="sections"
            :loading="sectionsTable.loading"
            item-key="id"
            :page="sectionsPagination.page"
            :server-items-length="sectionsPagination.total"
            :footer-props="{
              itemsPerPageOptions: sectionsTable.itemsPerPageOptions
            }"
            @pagination="setPagination"
          >
            <template v-slot:item.name="{ item }">
              <div class="font-weight-bold">
                {{ item.name }}
              </div>
              <div class="text-gray">
                {{ item.is_admin ? 'Admin' : 'General' }}
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <v-menu
                left
                offset-y
                nudge-bottom="10"
                transition="slide-y-transition"
                min-width="180px"
              >
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="openSectionEditor('detail', item.id)">
                    Detalles
                  </v-list-item>
                  <v-list-item @click="openSectionEditor('edit', item.id)">
                    Editar
                  </v-list-item>
                  <v-list-item @click="openSectionRemove(item.id)">
                    Eliminar
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template v-slot:no-data>
              <div class="text-center pa-12">
                <v-img
                  :src="require('@/assets/svg/box_empty.svg')"
                  height="150"
                  max-height="150px"
                  aspect-ratio="1"
                  contain
                />
                <div class="grey--text">
                  {{ $t('common.no_results_found') }}
                </div>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <SectionEditor />
    <SectionRemove />
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import SectionEditor from '@/components/Sections/Editor'
import SectionRemove from '@/components/Sections/Remove'

export default {
  components: {
    SectionEditor,
    SectionRemove
  },
  data () {
    return {
      sectionsTable: {
        loading: false,
        headers: [
          {
            text: 'ID',
            value: 'id',
            align: 'end',
            class: 'blue--text text--darken-4 text-right text-no-wrap',
            width: '0'
          },
          {
            text: 'Name',
            value: 'name',
            align: 'start',
            class: 'blue--text text--darken-4 text-right text-no-wrap',
            width: ''
          },
          {
            text: 'Description',
            value: 'description',
            align: 'start',
            class: 'blue--text text--darken-4 text-right text-no-wrap',
            width: ''
          },
          {
            text: '',
            value: 'action',
            align: 'center',
            class: '',
            sortable: false,
            width: '0'
          }
        ],
        itemsPerPageOptions: [
          { value: 5, text: 5 },
          { value: 10, text: 10 },
          { value: 15, text: 15 },
          { value: 25, text: 25 },
          { value: 100, text: 100 }
        ],
        pagination: {}
      }
    }
  },
  computed: {
    ...mapGetters({
      sections: 'sections/sections',
      sectionsPagination: 'sections/sectionsPagination',
      updateRequired: 'sections/updateRequired'
    })
  },
  watch: {
    updateRequired (newVal) {
      if (newVal) {
        this.getData()
      }
    }
  },
  created () {
    // this.getData()
  },
  destroyed () {
    this.resetState()
  },
  methods: {
    ...mapActions({
      resetState: 'sections/resetState',
      getSections: 'sections/getSections',
      getSection: 'sections/getSection'
    }),
    ...mapMutations({
      toggleUpdateRequired: 'sections/toggleUpdateRequired',
      toggleSectionEditor: 'sections/toggleSectionEditor',
      toggleSectionRemove: 'sections/toggleSectionRemove',
      setSectionEditorMode: 'sections/setSectionEditorMode',
      setSectionsPagination: 'sections/setSectionsPagination'
    }),
    async getData () {
      const {
        limit,
        offset
      } = this.sectionsPagination
      this.sectionsTable.loading = true
      await this.getSections({
        count: 'permissions',
        limit,
        offset
      })
      this.sectionsTable.loading = false
    },
    setPagination (pagination) {
      const {
        itemsPerPage,
        page
      } = pagination
      this.setSectionsPagination({
        ...this.sectionsPagination,
        limit: itemsPerPage,
        offset: page
      })
      this.getData()
    },
    async openSectionEditor (mode = 'create', id) {
      if (['edit', 'detail'].includes(mode)) {
        await this.getSection({ id, include: 'permissions' })
      }
      this.setSectionEditorMode(mode)
      this.toggleSectionEditor(true)
    },
    async openSectionRemove (id) {
      await this.getSection({ id })
      this.toggleSectionRemove(true)
    }
  }
}
</script>
